module.exports = __webpack_public_path__ + "img/dialog_coupon.5fa92bff.svg";